import { c as _c } from "react/compiler-runtime";
import { BackgroundTaskCategory } from "@custom-types/sdb-background-tasks-types";
import { ICON_SMALL_STYLE } from "@components/header/sphere-avatar";
import { CadSmallIcon, CameraVideoTrajectorySmallIcon, InfoIcon, PointCloudIcon, Tooltip } from "@flat-ui";

/**
 * Renders the backgrounds task icon to display in the cloud activity table.
 */
export function BackgroundTaskIcon(t0) {
  const $ = _c(9);
  const {
    task
  } = t0;
  let iconComponent;
  bb0: switch (task.taskCategory) {
    case BackgroundTaskCategory.pointCloud:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <PointCloudIcon style={ICON_SMALL_STYLE} />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        iconComponent = t1;
        break bb0;
      }
    case BackgroundTaskCategory.videoMode:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CameraVideoTrajectorySmallIcon style={ICON_SMALL_STYLE} />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        iconComponent = t1;
        break bb0;
      }
    case BackgroundTaskCategory.cad:
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CadSmallIcon style={ICON_SMALL_STYLE} />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        iconComponent = t1;
        break bb0;
      }
    default:
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <InfoIcon style={ICON_SMALL_STYLE} />;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        iconComponent = t1;
      }
  }
  let t1;
  if ($[4] !== task.taskType) {
    t1 = <var>{task.taskType}</var>;
    $[4] = task.taskType;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== iconComponent || $[7] !== t1) {
    t2 = <Tooltip component="div" title={t1}>{iconComponent}</Tooltip>;
    $[6] = iconComponent;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}